export default "__VITE_ASSET__CqIs29Au__"